































import Vue from 'vue';
import { getContentArea } from '@/contentful';

interface Data {
  helpContent: string;
}

export default Vue.extend({
  name: 'AlertBanner',
  data(): Data {
    return {
      helpContent: '',
    };
  },
  props: {
    bannerText: {
      type: String,
      required: false,
    },
    helpContentKey: {
      type: String,
      required: false,
    },
    bannerActionText: {
      type: String,
      required: false,
    },
    bannerActionRoute: {
      type: String,
      required: false,
    },
    bannerActionUrl: {
      type: String,
      required: false,
    },
  },
  mounted(): void {
    this.getHelpContent();
  },
  computed: {
    displayBannerActionInternal(): boolean {
      return !!this.bannerActionText && !!this.bannerActionRoute && !this.bannerActionUrl;
    },
    displayBannerActionExternal(): boolean {
      return !!this.bannerActionText && !!this.bannerActionUrl && !this.bannerActionRoute;
    },
    helpContentClass(): string {
      return this.helpContent ? 'v-alert__dark pb-0' : '';
    },
  },
  methods: {
    async getHelpContent(): Promise<void> {
      if (!this.helpContentKey) {
        return;
      }

      const CONTENT_AREAS = await getContentArea(this.helpContentKey);
      this.helpContent = CONTENT_AREAS.fields
        ? CONTENT_AREAS.fields.helpContent
        : '';
    },
  },
});
